import { useState, useEffect } from "react";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  MenuItem,
  Card,
  Modal,
  Box,
  Grid,
  TextField,
  Checkbox,
  ListItemText,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Encryption/Decryption
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";

function AddCouncilName({ isOpen, onRequestClose, id, fetchCoordinator }) {
  const [loading, setLoading] = useState(false);
  const [specializationList, setSpecializationList] = useState([]);
  const [counsilList, setCounsilList] = useState([]);

  const [customerDetails, setCustomerDetails] = useState({
    doctorid: id,
    counsil: [],
  });

  const fetchSpecializations = async () => {
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get("/api/specializationList", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setSpecializationList(decryptedData || []);
      }
    } catch (error) {
      console.error("Error fetching specialists:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCounsilNames = async () => {
    try {
      setLoading(true);
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get("/api/counsilNames", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setCounsilList(decryptedData || []);
      }
    } catch (error) {
      console.error("Error fetching counsil names:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSpecializations();
    fetchCounsilNames();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const secretKey = await fetchSecretKey();
      const rawPayload = {
       
        council: customerDetails?.counsil?.map((c) => ({
          doctorCounsilNames: c.doctorCounsilNames,
           doctorid: id,
        })),
      };

      const encryptedData = encryptBody(rawPayload, secretKey);
      const token = JSON.parse(localStorage.getItem("loginData")).token;

      const response = await axios.post("/api/doctorcounsilnames/create", encryptedData, {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        if (decryptedResponse?.success === true) {
          toast.success(
            decryptedResponse.message || "  Council Names Added successfully!"
          );
          setCustomerDetails({ specialization: [], counsil: [] });
          onRequestClose();
          if (typeof fetchCoordinator === "function") {
            fetchCoordinator();
           }
        } else {
          toast.error(
            decryptedResponse?.message || "Failed to Add Council Names."
          );
        }
      }
    } catch (error) {
      console.error("Registration Error:", error);
      toast.error(error.response?.data || "Failed to Add Council Names");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setCustomerDetails({ specialization: [], counsil: [] });
    onRequestClose();
  };

  return (
    <Modal open={isOpen} onClose={onRequestClose}>
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        p={2}
      >
        <Card
          sx={{
            width: { xs: "95%", sm: "90%", md: "600px" },
            padding: 3,
            margin: "auto",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <h5>Add Council</h5>
              </Grid>

             

              {/* Council Names */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Council Names"
                  fullWidth
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) =>
                      selected.length === 0
                        ? "Select Council Names"
                        : selected.join(", "),
                  }}
                  value={customerDetails.counsil.map(
                    (c) => c.doctorCounsilNames
                  )}
                  onChange={(e) => {
                    const value = e.target.value;
                    setCustomerDetails({
                      ...customerDetails,
                      counsil: value.map((val) => ({
                        doctorCounsilNames: val,
                      })),
                    });
                  }}
                      sx={{ "& .MuiInputBase-root": { height: "45px" } }}

                >
                  {loading ? (
                    <MenuItem disabled>Loading...</MenuItem>
                  ) : counsilList.length > 0 ? (
                    counsilList.map((c) => (
                      <MenuItem key={c.id} value={c.counsilname}>
                        <Checkbox
                          checked={customerDetails.counsil.some(
                            (cn) => cn.doctorCounsilNames === c.counsilname
                          )}
                        />
                        <ListItemText primary={c.counsilname} />
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No council names available</MenuItem>
                  )}
                </TextField>
              </Grid>
            </Grid>

            {/* Buttons */}
            <MDBox mt={3} display="flex" justifyContent="flex-end" gap={2}>
               <MDButton
                variant="contained"
                type="submit"
               sx={{
      background: "#1A237E !important",  // force override gradient bg
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#1A237E !important", // keep same color
        boxShadow: "none !important",
      },
      "&:focus": {
        background: "#1A237E !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#1A237E !important",
        boxShadow: "none !important",
      },
    }}
              >
                Submit
              </MDButton>
              <MDButton
                variant="outlined"
                onClick={handleCancel}
                sx={{
      background: "#1A237E !important",  // force override gradient bg
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#1A237E !important", // keep same color
        boxShadow: "none !important",
      },
      "&:focus": {
        background: "#1A237E !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#1A237E !important",
        boxShadow: "none !important",
      },
    }}
              >
                Cancel
              </MDButton>
             
            </MDBox>
          </form>
        </Card>
      </MDBox>
    </Modal>
  );
}

export default AddCouncilName;
